import styled, { keyframes } from 'styled-components'
import { colors } from 'styles'

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

const StyledEmptyState = styled.div`
  margin-top: 20px;
  text-align: center;
  color: ${colors.textSecondary};

  h3,
  .screen-name {
    color: ${colors.textMain};
  }
  .empty-logo {
    max-width: 80%;
    margin: 0 auto;
  }
  .users {
    margin-top: 10px;
  }
  .user {
    transition: 0.2s ease-in-out;
    margin: 5px;
    &:hover {
      transform: scale(1.2);
      cursor: pointer;
    }
  }
  .location {
    font-size: 10px;
    opacity: 0.8;
  }

  .photo {
    max-width: 100%;
    border-radius: 50%;
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;

    &::before {
      padding-top: 100%;
      display: block;
      content: '';
    }
  }
  .screen-name {
    font-weight: 700;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .chat-widget-open & {
    .user {
      display: inline-block;
      vertical-align: top;
      max-width: 20%;
    }
  }

  .chat-widget-minimized & {
    margin-top: 10px;

    .empty-logo,
    h3,
    p,
    .screen-name,
    .location {
      display: none;
    }

    .users {
      flex-flow: column nowrap;
    }
    .user:hover {
      transform: none;
    }
    .photo {
      opacity: 0;
      animation: ${fadeIn} 0.3s 0.5s ease-in forwards;
    }
  }
`

export default StyledEmptyState
